const Skill = () => {

  return (
    <div className="container-fluid" id="skills">
      <h3 className="skills-title underline justify-content-center">SKILLS</h3>
      <div className="row">
        <div className='col-lg-6 col-md-12'>
          <div className="skills-text">
            <dl className="skills-list">
              <dt className="skill-name">OOPs</dt>
              <dd className="skill-percent" data-percent="90%" style={{width: '90%'}}></dd>
              <dt className="skill-name">Data Structure</dt>
              <dd className="skill-percent" data-percent="80%" style={{width: '80%'}}></dd>
              <dt className="skill-name">Python</dt>
              <dd className="skill-percent" data-percent="50%" style={{width: '50%'}}></dd>
              <dt className="skill-name">GIT</dt>
              <dd className="skill-percent" data-percent="60%" style={{width: '60%'}}></dd>
              <dt className="skill-name">Deployment(Heruko)</dt>
              <dd className="skill-percent" data-percent="60%" style={{width: '50%'}}></dd>
              <dt className="skill-name">JQuery/Ajax</dt>
              <dd className="skill-percent" data-percent="70%" style={{width: '70%'}}></dd>
            </dl>
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="skills-text">
            <dl className="skills-list">
              <dt className="skill-name">Ruby On Rails</dt>
              <dd className="skill-percent" data-percent="60%" style={{width: '95%'}}></dd>
              <dt className="skill-name">ReatJS</dt>
              <dd className="skill-percent" data-percent="50%" style={{width: '75%'}}></dd>
              <dt className="skill-name">HTML5</dt>
              <dd className="skill-percent" data-percent="90%" style={{width: '90%'}}></dd>
              <dt className="skill-name">CSS3</dt>
              <dd className="skill-percent" data-percent="80%" style={{width: '80%'}}></dd>
              <dt className="skill-name">SCSS</dt>
              <dd className="skill-percent" data-percent="22%" style={{width: '80%'}}></dd>
              <dt className="skill-name">Javascript</dt>
              <dd className="skill-percent" data-percent="70%" style={{width: '70%'}}></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Skill